import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import Seo from '../components/Seo';
import InsurancePlans from '../components/InsurancePlans';

function ReferringPractices() {
  return (
    <div className="referring-page">
      <Seo
        title="Pathology for Referring Practices in Florida"
        path="/referring-practices"
        description="Turnaround, specimen logistics and courier setup for GI practices, endoscopy and surgery centers, and dermatology groups referring cases to our Florida lab."
      />
      <section className="page-banner">
        <p className="section-label">For Referring Practices</p>
        <h1>Partner With Our Lab</h1>
        <p>Pathology support built for surgical centers, GI practices, and dermatology groups that need fast, reliable turnaround and direct access to the reading pathologist when questions come up.</p>
      </section>

      <section className="quality-assurance">
        <p className="section-label">Service Levels</p>
        <h2>Turnaround You Can Plan Around</h2>
        <div className="quality-grid">
          <div className="quality-item">
            <Icon name="clock" className="card-icon" />
            <h3>24-48 Hours</h3>
            <p>Typical turnaround for routine surgical pathology and cytopathology cases.</p>
          </div>
          <div className="quality-item">
            <Icon name="clock" className="card-icon" />
            <h3>3-5 Business Days</h3>
            <p>For cases requiring special stains or immunohistochemistry.</p>
          </div>
          <div className="quality-item">
            <Icon name="flag" className="card-icon" />
            <h3>Urgent Cases Prioritized</h3>
            <p>Time-sensitive specimens are flagged, and we communicate delays before you have to ask.</p>
          </div>
          <div className="quality-item">
            <Icon name="phone" className="card-icon" />
            <h3>Direct Pathologist Access</h3>
            <p>Questions about a case go straight to the reading pathologist, not a call center.</p>
          </div>
        </div>
      </section>

      <section>
        <p className="section-label">Logistics</p>
        <h2>Specimen Logistics, Handled</h2>
        <div className="service-grid">
          <div className="service-item">
            <Icon name="truck" className="card-icon" />
            <h3>Regional Pickup</h3>
            <p>We accept specimens from hospitals, surgical centers, and clinics throughout Florida and beyond.</p>
          </div>
          <div className="service-item">
            <Icon name="shield" className="card-icon" />
            <h3>Established Protocols</h3>
            <p>Transport and handling procedures protect sample integrity from your facility to our lab.</p>
          </div>
          <div className="service-item">
            <Icon name="fileCheck" className="card-icon" />
            <h3>Results Delivery</h3>
            <p>Reports are available through our secure provider portal, with delivery options we can tailor to your practice's workflow.</p>
          </div>
        </div>
      </section>

      <section className="insurance" id="insurance">
        <p className="section-label">Billing</p>
        <h2>Insurance We Accept</h2>
        <p className="insurance-intro">We accept Medicare, Medicaid, and TRICARE along with the major health plans below, so your patients&rsquo; coverage doesn&rsquo;t hold up a referral.</p>
        <InsurancePlans />
        <p className="insurance-note">Participation can vary by plan and product, and can change. Call <a href="tel:+15616387577">(561) 638-7577</a> to confirm a specific plan.</p>
      </section>

      <section className="cta-section">
        <p className="section-label">Get Started</p>
        <h2>Ready to Send Us Your First Case?</h2>
        <p>Tell us about your practice and we'll set up courier pickup, portal access, and billing details.</p>
        <div className="cta-buttons">
          <Link to="/contact?type=new-practice" className="cta-button">Become a Referring Practice</Link>
          <a href="tel:+15616387577" className="cta-button secondary">Call (561) 638-7577</a>
        </div>
      </section>
    </div>
  );
}

export default ReferringPractices;
